import React, { useEffect } from 'react';
import './App.css';
import { BsPaypal } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import Navbar from "./components/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import Reviews from "./pages/Reviews";
import Search from './pages/Search';
import WriteReview from './pages/WriteReview';

const App = () => {

  useEffect(() => {
    let welcomeCard = document.getElementById("welcome");
    let welcome = localStorage.getItem("Welcome");
    if (welcome == "false") {
      welcomeCard.style.display = "none";
    } else {
      welcomeCard.style.display = "block";
    }

    // Google
    const script = document.createElement("script");

    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2436004003768296";
    script.async = true;
  	script.crossorigin = "anonymous";

    document.body.appendChild(script);
  }, [])

  const date = new Date(),
        year = date.getFullYear();

  const closeWelcome = () => {
    let welcomeCard = document.getElementById("welcome");
    welcomeCard.style.display = "none";
    localStorage.setItem("Welcome", "false");
  }

  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
          <Route index element={<Home />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="search" element={<Search />} />
          <Route path="write-review" element={<WriteReview />} />
      </Routes>
      <div className="welcome" id="welcome">
        <span className="close" title="Close" onClick={closeWelcome}><CgClose /></span>
        <h4><span style={{ fontSize: "20px", marginRight: "5px" }}>👋</span> Welcome to Veta</h4>
        <p>
          We're a new website, so if you exeperience any issues, let us know at 
          <u> boularbahismail01@gmail.com</u>, We appreciate the feedback!
        </p>
      </div>
      <div className="copyright">
        <a href="https://paypal.me/ismailium" target="_blank" className="Donate">
          <BsPaypal />
          <span>Donate</span>
        </a>
            <h5>
              <b>&copy; {year} - Veta</b> <br /> Made with ❤️ by <a href="https://twitter.com/boularbahsmail" target="_blank" title="Twitter">Ismailium</a>
            </h5>
        </div>
    </BrowserRouter>
  );
}

export default App;
